@if (items().length > 0) {
  <div class="relative h-full w-full">
    <p-table
      class="h-full w-full"
      showGridlines
      selectionMode="single"
      dataKey="id"
      scrollHeight="flex"
      [columns]="columns()"
      [value]="items()"
      [tableStyle]="{ width: '100%', 'min-width': '50rem' }"
      [scrollable]="true"
      [virtualScroll]="virtualScroll()"
      [virtualScrollItemSize]="40"
      (onRowSelect)="onRowSelect($event)"
    >
      <ng-template #header let-columns>
        <tr class="h-10">
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field">
              <div class="col_content">
                <span>{{ col.header }} </span>
                <p-sortIcon [field]="col.field" />
              </div>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr class="h-10" [pSelectableRow]="rowData">
          @for (col of columns; track col) {
            <td>
              <div class="flexCenter">
                @if (isDate(rowData[col.field]) && col.type === DataType.Date) {
                  {{ convertToDateObj(rowData[col.field]) | date: 'dd-MM-yyyy' }}
                }
                @if (!isDate(rowData[col.field]) && col.type === DataType.Date) {
                  {{ rowData[col.field] }}
                }
                @if (col.type === DataType.String || col.type === DataType.Integral) {
                  {{ rowData[col.field] }}
                }
                @if (col.type === DataType.Decimal0) {
                  {{ rowData[col.field] | number: '1.0-0' }}
                }
                @if (col.type === DataType.Decimal1) {
                  {{ rowData[col.field] | number: '1.1-1' }}
                }
                @if (col.type === DataType.Decimal2) {
                  {{ rowData[col.field] | number: '1.1-2' }}
                }
                @if (col.type === DataType.DecimalHours) {
                  {{ rowData[col.field] | decimalHours }}
                }
                @if (col.type === DataType.Icon) {
                  @let iconData = getStatusIconData(rowData[col.field]);
                  @if (iconData) {
                    <nsp-icon [name]="iconData.name" [class]="iconData.class" />
                  }
                }
                @if (col.type === DataType.ReportBadge) {
                  <span class="flex w-full justify-center">
                    <nsp-report-badge [reportType]="rowData[col.field]" class="whitespace-nowrap"></nsp-report-badge>
                  </span>
                }
                @if (rowData[col.field] === undefined) {
                  -
                }
              </div>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>

    @if (showScrollTop) {
      <button
        type="button"
        class="absolute right-6 bottom-2 z-20 flex h-9 w-9 items-center justify-center rounded-full border border-[#2f4c73] bg-[#1a2841] text-[#f4f4f5] shadow-md transition hover:bg-[#223654]"
        aria-label="Scroll table to top"
        (click)="scrollToTop()"
      >
        <nsp-icon [name]="IconNames.ArrowUp" />
      </button>
    }
  </div>
}
